import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-last-records',
  templateUrl: './last-records.component.html',
  styleUrls: ['./last-records.component.scss']
})
export class LastRecordsComponent {
  @Input() title = 'Últimos Registros';
  @Input() tabs: Array<{ label: string, value: 'imc' | 'weight' }> = [];
  @Input() isNutrition: boolean = false;

  @Output() tabChange = new EventEmitter<'imc' | 'weight'>();

  activeTab: 'imc' | 'weight' | null = null;

  ngOnInit() {
    if (this.tabs && this.tabs.length > 0) {
      this.activeTab = this.tabs[0].value;
    }
  }

  selectTab(tabValue: 'imc' | 'weight') {
    this.activeTab = tabValue;
    this.tabChange.emit(tabValue);
  }
}
